import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
// import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	sortAndFilterItems(items) {
		const filtered = super.sortAndFilterItems(items);
		const hasRegionMatch = filtered.some(item => item.userRegion && item.key !== 'privacy-fallback');
		return hasRegionMatch ? filtered.filter(item => item.key !== 'privacy-fallback') : filtered;
	}
}
